const route = [
    {
        path: '/activity/2024winter/preheat', //寒假教师活动预热
        component: function (resolve) {
            require(['VIEWS/activity/2024winter/preheat.vue'], resolve);
        }
    },
    {
        path: '/activity/2024winter/timing', //寒假教师活动定时
        component: function (resolve) {
            require(['VIEWS/activity/2024winter/timing.vue'], resolve);
        }
    },
    {
        path: '/activity/2024winter/index', //寒假教师活动首页
        component: function (resolve) {
            require(['VIEWS/activity/2024winter/index.vue'], resolve);
        }
    },
    {
        path: '/activity/2024winter/pointsdetail', //积分明细
        component: function (resolve) {
            require(['VIEWS/activity/2024winter/pointsDetail.vue'], resolve);
        }
    },
    {
        path: '/activity/2024winter/preview/:sid/:unit_class_id', //预览作业
        component: function (resolve) {
            require(['VIEWS/activity/2024winter/preview.vue'], resolve);
        }
    },
    {
        path: '/activity/2024winter/viewDetail/:sid/:unit_class_id', //查看完成情况
        component: function (resolve) {
            require(['VIEWS/activity/2024winter/viewDetail.vue'], resolve);
        }
    },
    {
        path: '/activity/2024winter/viewLessonDetail/:sid/:unit_class_id/:paper_id', //新课预习完成情况
        component: function (resolve) {
            require(['VIEWS/activity/2024winter/viewLessonDetai.vue'], resolve);
        }
    },
    {
        path: '/activity/2024winter/chinesePreview/:sid/:paper_id', //语文新课预习
        component: function (resolve) {
            require(['VIEWS/activity/2024winter/chinesePreview.vue'], resolve);
        }
    },
    {
        path: '/activity/2024winter/kwld/:paper_id', //语文新课预习
        component: function (resolve) {
            require(['VIEWS/activity/2024winter/kwld.vue'], resolve);
        }
    },
    {
        path: '/activity/2024winter/sf_detail/:unit_class_id', //书法完成情况首页
        component: function (resolve) {
            require(['VIEWS/activity/2024winter/sf_clock/home.vue'], resolve);
        }
    },
    {
        path: '/activity/2024winter/sf_ranking/:unit_class_id', //书法完成情况排行榜
        component: function (resolve) {
            require(['VIEWS/activity/2024winter/sf_clock/ranking.vue'], resolve);
        }
    },
]
export default route;
